import * as React from 'react';
export const LRSvg = React.forwardRef(function LRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 3.091h16v1.091H0zm0 2.182h16v1.091H0zm0 2.182h16v1.091H0zm0 2.181h16v1.091H0zm0 2.182h16v1.091H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V8h1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8V2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      opacity: 0.1,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M0 8.55V3.871C0 2.838.869 2 1.94 2h4.61v6.55H0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'm5.069 4.711-1.14.003a.158.158 0 0 1-.15-.11L3.426 3.52a.158.158 0 0 0-.302 0l-.352 1.084a.158.158 0 0 1-.15.11h-1.14A.158.158 0 0 0 1.389 5l.921.67c.056.04.08.112.058.178l-.352 1.084a.158.158 0 0 0 .244.177l.922-.618a.16.16 0 0 1 .187 0l.922.618a.158.158 0 0 0 .244-.177l-.353-1.084a.158.158 0 0 1 .058-.178L5.162 5a.16.16 0 0 0-.093-.29Z',
    }),
  );
});
LRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LR = {
  category: 'flag',
  colorable: false,
  name: 'LR',
  svg: LRSvg,
};
